// extracted by mini-css-extract-plugin
export default {"close":"BuildingTypeSelectionDialog_close__IgLTc","next":"BuildingTypeSelectionDialog_next__0lvjF","content":"BuildingTypeSelectionDialog_content__nJiGO"};